import Layout from '@/layout'

const route = {
  path: '/monitoringManagement',
  component: Layout,
  // redirect: '/customer/publicPlan/index',
  alwaysShow: true, // will always show the root menu
  name: 'Customer',
  meta: {
    title: '监测管理',
    icon: 'monitorManage',

    roles: [
      'wechat.mini_program'
    ]
  },
  children: [
    {
      path: '/adminAdvertMangement/wechatApplet',
      component() {
        return import('@/views/wechatApplet/index.vue')
      },
      name: 'Applet',
      meta: {
        title: '小程序',
        roles: [
          'wechat.mini_program.index'
        ]
      }
    },
    {
      path: '/adminAdvertMangement/callrecord',
      component() {
        return import('@/views/callrecord/index.vue')
      },
      name: 'InstantCall',
      meta: {
        title: '即信呼叫记录',
        roles: [
          'jixin.record.index'
        ]
      }
    },
    {
      path: '/report/WeChatAccountFans/index',
      component: () => import('@/views/report/WeChatAccountFans/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '回传配置',
        icon: 'component',
        roles: [
          'platform.py_platform_account.index'
        ]
      }
    },
    {
      path: '/detectlinks/detectlinksing/index',
      component: () => import('@/views/detectlinksing/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '检测链接',
        icon: 'component',
        roles: [
          'ad_url.index'
        ]
      }
    },
    {
      path: '/readingshortplays/index',
      component: () => import('@/views/readingshortplayslink/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '番茄短剧上新',
        icon: 'component',
        roles: [
          'changdu.playlet'
        ]
      }
    },
    {
      path: '/adminAdvertMangement/yuewenMonitor',
      component: () => import('@/views/yuewenMonitor/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '阅文回传',
        icon: 'component',
        roles: [
          'yuewen.put_monitor'
        ]
      }
    },
    {
      path: '/adminAdvertMangement/hongGuo',
      component: () => import('@/views/hongGuoPlaysLink/index.vue'),
      name: 'HongGuo',
      meta: {
        title: '红果短剧上新',
        icon: 'component',
        roles: [
          'hongguo.playlet'
        ]
      }
    },
    {
      path: '/advertisermonitor/monitoring',
      component: () => import('@/views/advertisermonitor/index.vue'),
      name: 'HongGuo',
      meta: {
        title: '广告主监控',
        icon: 'component',
        roles: [
          'ad_evaluation_config'
        ]
      }
    }

    /*  {
      path: 'merchantMaintenanceNumber/index',
      name: 'merchantMaintenanceNumber',
      component: () => import('@/views/messageTemplate/index.vue'),
      meta: {
        title: '商户养号',
        roles: [
          'advertisers.index'
        ]
      },
      children: [{
        path: '/denterpriselinks/denterpriselinksing/index',
        component: () => import('@/views/denterpriselinksing/index.vue'),
        name: 'BackConfig',
        meta: {
          title: '企业微信',
          icon: 'component',
          roles: [
            'wechat_company.index'
          ]
        }
      },
      {
        path: '/merchantpay/merchantpaying/index',
        component: () => import('@/views/merchantpaying/index.vue'),
        name: 'BackConfig',
        meta: {
          title: '商户号支付',
          icon: 'component',
          roles: [
            'pay_code.index'
          ]
        }
      }]
    } */
  ]
}

export default route
